export const state = {
  current: null,
  currentMembers: [],
  currentProjectMembers: [],
  currentInvites: [],
  orgs: [],
  selectedOrg: null, // org id,
  apikeys: []
}
